var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTaxableAccounts = function SvgTaxableAccounts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    fill: "none",
    viewBox: "0 0 128 128"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DAD6CD",
    d: "M105.635 14.676v100.526c0 4.427-3.745 8.019-8.36 8.019h-74.58c-.724 0-1.432-.09-2.106-.262-3.6-.898-6.253-4.026-6.253-7.757V14.676c0-4.432 3.745-8.02 8.36-8.02h74.58c4.614 0 8.359 3.588 8.359 8.02"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B216B",
    d: "M107.837 48.055H42.179a7.2 7.2 0 0 0-7.2 7.198v40.704a7.2 7.2 0 0 0 7.2 7.199h65.658a7.2 7.2 0 0 0 7.199-7.199V55.253a7.2 7.2 0 0 0-7.199-7.198"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4154AE",
    d: "M62.382 48.055v55.101H42.18a7.195 7.195 0 0 1-7.2-7.199V55.253a7.196 7.196 0 0 1 7.2-7.198z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBE1FF",
    d: "M106.716 60.43h-60v4h60z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1BDFF",
    d: "M62.216 60.43h-15.5v4h15.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#DBE1FF",
    d: "M106.716 69.43h-60v4h60z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1BDFF",
    d: "M62.216 69.43h-15.5v4h15.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1BDFF",
    fillRule: "evenodd",
    d: "M66.18 89.33c.32.4.74.6 1.163.6.413 0 .82-.191 1.14-.571L71.272 86l2.125 2.523 3.184-1.963 1.985 2h26.524c.899 0 1.625-.896 1.625-1.996s-.726-1.995-1.625-1.995H79.73l-2.722-2.735L74 83.69l-2.744-3.258-5.052 6.077c-.642.772-.652 2.035-.023 2.823",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA5B",
    d: "M105.659 61.797c12.263 0 22.203-9.708 22.203-21.683s-9.94-21.682-22.203-21.682-22.203 9.707-22.203 21.682 9.94 21.683 22.203 21.683"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD00",
    d: "M105.718 61.791V18.438h-.059c-12.263 0-22.203 9.707-22.203 21.682 0 11.976 9.94 21.683 22.203 21.683h.059z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#4154AE",
    d: "M116.404 33.765h1.784v7.001h-7.168v-1.731h3.9c-1.601-2.944-5.13-5.345-9.55-5.281-4.935.075-9.438 3.44-10.425 8.772h-1.808c.561-3.878 3.327-8.183 8.421-9.863 5.1-1.685 11.465-.098 14.846 5.321v-4.219"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#4154AE",
    d: "M95.73 43.489h-3.57l.142-.987c.532-3.676 3.215-8.645 9.013-10.567 5.147-1.703 10.667-.237 14.248 3.555v-2.493h3.558v8.732h-8.942v-3.463h3.15c-1.814-2.24-4.769-3.607-7.901-3.55-4.769.07-8.705 3.388-9.568 8.057l-.13.71zm-1.478-1.731h.018c.19-.757.45-1.484.768-2.165a12 12 0 0 0-.786 2.165m23.084-1.755h.012l-.012-5.27zm-5.384 0h4.663l-.922-1.472c-2.299-3.682-5.868-5.298-9.266-5.511 3.953.271 7.541 2.441 9.319 5.713l.692 1.27z"
  })));
};
export { SvgTaxableAccounts as Icon };
export default __webpack_public_path__ + "static/media/5526d28a8fdc3a9dc18cf7b7bdf75829.svg";